import ViewStatistics from 'scenes/Dialog/components/ViewStatistics/index';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog/index';
import UpgradeCandidateAccount from 'scenes/Dialog/components/UpgradeCandidateAccount/index';
import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';

import { ENDPOINT } from 'constants/endpoints';
import { REASON } from 'constants/reasons';
import { UPGRADE_ACCOUNT_TYPE } from 'constants/upgrade-account-types';

const TYPE = {
  JOB: 'Job',
  PROJECT: 'Project',
  SHORTLIST: 'Shortlist',
};

export class ViewStatisticsActions {
  constructor(api, history, user) {
    this.api = api;
    this.history = history;
    this.user = user;
  }

  _view = (id, endpoint, type) => {
    return new Promise(resolve => {
      this.api.get(
        endpoint,
        { id },
        {
          handleError: response => {
            if (
              response.data &&
              response.data.reason &&
              response.data.reason === REASON.INSUFFICIENT_CANDIDATE_LEVEL
            ) {
              if (
                UPGRADE_ACCOUNT_TYPE.RECRUITER === this.user.accountUpgradeType
              ) {
                UpgradeRecruiterAccount();
              } else {
                UpgradeCandidateAccount({ history: this.history });
              }
            } else {
              ResponseErrorDialog({ response });
            }
          },
          handleSuccess: statistics =>
            ViewStatistics({
              data: statistics,
              title: `${type} Statistics`,
            }),
          handleComplete: resolve,
        }
      );
    });
  };

  job = id => this._view(id, ENDPOINT.ACTION.VIEW_STATISTICS.JOB, TYPE.JOB);

  jobExtended = id =>
    this._view(id, ENDPOINT.ACTION.VIEW_STATISTICS.JOB_EXTENDED, TYPE.JOB);

  project = id =>
    this._view(id, ENDPOINT.ACTION.VIEW_STATISTICS.PROJECT, TYPE.PROJECT);

  projectExtended = id =>
    this._view(
      id,
      ENDPOINT.ACTION.VIEW_STATISTICS.PROJECT_EXTENDED,
      TYPE.PROJECT
    );

  shortlist = id =>
    this._view(id, ENDPOINT.ACTION.VIEW_STATISTICS.SHORTLIST, TYPE.SHORTLIST);
}
